import React from "react";

function UntaggedPool({ className = "", stockData }) {
  const rows = Array.isArray(stockData?.untagged_pool_by_product_group)
    ? stockData.untagged_pool_by_product_group
    : [];

  const topRows = rows.slice(0, 6);

  return (
    <div className={`col-lg-3 col-md-5 col-12 ${className}`.trim()}>
      <div
        className="card shadow-none border-0"
        style={{
          minHeight: "285px",
          height: "285px",
          overflow: "hidden",
          borderRadius: "18px",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-4 pb-3 d-flex flex-column h-100">
          <div className="mb-2">
            <span
              className="d-block"
              style={{
                fontSize: "0.875rem",
                color: "#334155",
                fontWeight: 500,
              }}
            >
              Untagged Pool
            </span>
            <p className="text-muted small mb-0">
              Metal in product group pools (nwt + pcs)
            </p>
          </div>
          <div className="flex-grow-1 overflow-auto">
            {topRows.length === 0 ? (
              <p className="text-muted small mb-0">No pool balances reported</p>
            ) : (
              <table className="table table-sm table-borderless mb-0 small">
                <thead>
                  <tr className="text-muted">
                    <th>Group</th>
                    <th className="text-end">N.Wt</th>
                    <th className="text-end">Pcs</th>
                  </tr>
                </thead>
                <tbody>
                  {topRows.map((row) => (
                    <tr key={row.product_group_id}>
                      <td className="text-truncate" style={{ maxWidth: 120 }}>
                        {row.product_group_name || `#${row.product_group_id}`}
                      </td>
                      <td className="text-end text-nowrap">
                        {Number(row.pool_nwt ?? 0).toLocaleString("en-IN", {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}
                      </td>
                      <td className="text-end text-nowrap">
                        {Number(row.pool_pcs ?? 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UntaggedPool;
